import { UPLOADED_COMMENTS_TAB_I18N_KEYS } from '../../../../../features/home/components/constants/i18n/UploadedCommentsTabi18nConstants';

export const UPLOADED_COMMENTS_TAB_I18N_EN =  {
  [UPLOADED_COMMENTS_TAB_I18N_KEYS.no_articles_uploaded_comments_tab_message]: "Please check your Topic and files uploaded. Otherwise, contact us for assistance.",
  [UPLOADED_COMMENTS_TAB_I18N_KEYS.its_empty_uploaded_comments_tab_message]:   "Upload files for the topic and the data will appear here."
}


// WEBPACK FOOTER //
// ./src/locales/en/features/home/components/uploaded_comments_tab.i18n.en.js